import { BaseModal } from "@/components";
import clsx from "clsx";
import "./CardInfoDoctorModal.scss";
import { PropsWithChildren, ReactNode } from "react";
import { CardInfoDoctorModalContent } from "./CardInfoDoctorModalContent";
import { CardInfoDoctorModalHeader } from "./CardInfoDoctorModalHeader";
type CardInfoDoctorModalProps = PropsWithChildren<{
  open: boolean;
  overrideClassNames?: string;
  overrideBaseModalClassName?: string;
  setOpen: (open: boolean) => void;
  role?: string;
  children: ReactNode;
}>;

const CardInfoDoctorModal = ({
  open,
  overrideClassNames,
  overrideBaseModalClassName,
  setOpen,
  children,
  role,
}: CardInfoDoctorModalProps) => {
  return (
    <BaseModal
      overrideBaseModalClassName={overrideBaseModalClassName}
      open={open}
      setOpen={setOpen}
      overrideClassNames={clsx(
        "ui-card-info-modal-override",
        overrideClassNames,
      )}
      role={role}
    >
      {children}
    </BaseModal>
  );
};

CardInfoDoctorModal.Header = CardInfoDoctorModalHeader;
CardInfoDoctorModal.Content = CardInfoDoctorModalContent;

export { CardInfoDoctorModal };
